import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";
import Numeral from "numeral";

import { useTranslation } from "next-i18next";
import { useEboxContext } from "ab-context-ebox";
import Text from "ab-text";
import ParagraphText from "ab-paragraph-text";
import CardEBox from "ab-card-e-box";
import { getTranslation } from "ab-functions";

import "./select-e-box.scss";
import { filter, find, map, sum } from "lodash-es";

const SelectEbox = ({
  title = "Una experiencia gastronómica",
  text = [],
  content,
  contenidodebajo,
  tipo,
  product,
  products,
  className = "",
  classname = "",
  animated,
  singleColumn,
  singlecolumn,
  element = "h2",
  textClass,
  textclass,
  hidePriceDetails = false,
  subtitle,
  navlink,
  upsellingModal,
  i18n,
}) => {
  const [selected, setSelected] = useState(1);
  const [stateEbox, dispatchEbox] = useEboxContext();
  const { itemsEbox } = stateEbox;
  const { addItemToEbox, resetEbox, removeItemFromEbox } = dispatchEbox;

  const alojamiento1Noche = product?.configuradorEbox?.estancias?.length
    ? find(
      product?.configuradorEbox?.estancias,
      (product) => product?.producto?.sku == "EB00031"
    )?.producto
    : find(products, (product) => product?.sku == "EB00031");
  const alojamiento2Noche = product?.configuradorEbox?.estancias?.length
    ? find(
      product?.configuradorEbox?.estancias,
      (product) => product?.producto?.sku == "EB00032"
    )?.producto
    : find(products, (product) => product?.sku == "EB00032");
  const _products = filter(
    products,
    (product) => product?.price || product?.producto?.price
  );

  const myRef = useRef();
  const { t } = useTranslation("common", { i18n });
  // console.log("SelectEbox", product?.configuradorEbox?.fijas);
  const precioFijas = map(
    product?.configuradorEbox?.fijas,
    (fija) =>
      `${fija?.producto?.name || fija?.producto?.sku || "EB"} - ${Numeral(
        fija?.producto.price
      ).format("1,000[.]00$")}`
  );
  // console.log("SelectEbox - products", products, itemsEbox);
  const total1Noche =
    parseFloat(alojamiento1Noche?.price?.replace(".", "")) +
    sum(
      map(product?.configuradorEbox?.fijas, (fija) =>
        parseFloat(fija?.producto?.price?.replace(".", ""))
      )
    );
  const total2Noches =
    parseFloat(alojamiento2Noche?.price?.replace(".", "")) +
    sum(
      map(product?.configuradorEbox?.fijas, (fija) =>
        parseFloat(fija?.producto?.price?.replace(".", ""))
      )
    );

  // useEffect(() => {
  //   if (alojamiento1Noche && alojamiento1Noche?.sku) {
  //     addItemToEbox(alojamiento1Noche);
  //   }
  // }, []);
  useEffect(() => {
    if (
      tipo == "Dias" &&
      selected == 1 &&
      alojamiento1Noche &&
      alojamiento1Noche?.sku
    ) {
      addItemToEbox(alojamiento1Noche);
    }
  }, [product]);

  useEffect(() => {
    const slider = document.querySelector(
      upsellingModal ? "#select-e-box-upselling" : "#select-e-box"
    );
    const myBar = document.querySelector("#myBar");
    const myBarContainer = document.querySelector("#indicator-container");

    let isDown = false;
    let startX;
    let scrollLeft;
    if (slider) {
      const down = (e) => {
        isDown = true;
        // slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      };
      const leave = () => {
        isDown = false;
        slider.classList.remove("active");
      };
      const up = () => {
        isDown = false;
        slider.classList.remove("active");
        slider.classList.remove("prevent-clic");
      };
      const move = (e) => {
        if (!isDown) return;
        e.preventDefault();
        slider.classList.add("active");
        slider.classList.add("prevent-clic");
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        if (myBar && myBarContainer) {
          const percent =
            slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);

          const percentScroll = myBarContainer?.clientWidth;
          myBar.style.left = `${percent * percentScroll}px`;
        }
      };

      slider.addEventListener("mousedown", down);
      // slider.addEventListener('touchstart', down);
      slider.addEventListener("mouseleave", leave);
      // slider.addEventListener('touchcancel', leave);
      slider.addEventListener("mouseup", up);
      // slider.addEventListener('touchend', up);
      slider.addEventListener("mousemove", move);
      // slider.addEventListener('touchmove', move);

      slider.addEventListener("mouseover", (e) => { });
    }

    document.addEventListener("mousemove", (e) => { });
  }, []);

  const myRef2 = useRef();

  const { inViewport, enterCount, leaveCount } = useInViewport(
    myRef2,
    { threshold: 0.5 },
    {
      onEnterViewport: () => {
        // console.log("entered viewport");
      },
    },
    { disconnectOnLeave: false }
  );
  const handleScroll = () => {
    const element = document.getElementById(`menu-#${navlink}`);
    const menu = document.getElementById("history-menu");

    if (element) {
      if (inViewport) {
        if (!element?.classList?.contains("selected")) {
          const children = menu?.querySelectorAll("li");
          children.forEach(function (e) {
            if (e.id !== element.id) {
              e?.classList.remove("selected");
              e?.classList.add("not-selected");
            }
          });
          element?.classList.add("selected");
          element?.classList.remove("not-selected");
          menu.scrollLeft = element?.offsetLeft - 10;
        }
      } else {
        if (!element?.classList?.contains("not-selected")) {
          element?.classList.remove("selected");
          element?.classList.add("not-selected");
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inViewport]);

  if (Numeral.locales["abadia"] === undefined) {
    Numeral.register("locale", "abadia", {
      delimiters: {
        thousands: ".",
        decimal: ",",
      },
      abbreviations: {
        thousand: "k",
        million: "mm",
        billion: "b",
        trillion: "t",
      },
      ordinal: function (number) {
        var b = number % 10;
        return b === 1 || b === 3
          ? "er"
          : b === 2
            ? "do"
            : b === 7 || b === 0
              ? "mo"
              : b === 8
                ? "vo"
                : b === 9
                  ? "no"
                  : "to";
      },
      currency: {
        symbol: "€",
      },
    });
  }
  Numeral.locale("abadia");

  const renderCards = () => {
    return (
      <div
        style={
          upsellingModal && _products?.length < 3
            ? { alignItems: "baseline" }
            : {}
        }
      >
        <div
          className="row"
          id={upsellingModal ? "select-e-box-upselling" : "select-e-box"}
          ref={myRef}
        >
          {_products?.map((itm, index) => {
            // console.log("SelectEbox itm", itm);
            const producto = itm?.producto || itm;
            const selected = filter(
              itemsEbox,
              (itemEbox) => itemEbox?.sku == (itm?.sku || itm?.producto?.sku)
            );
            // console.log("selected itemsEbox", selected);

            return (
              <CardEBox
                src={producto?.src || producto?.image?.mediaItemUrl}
                srcSet={producto?.srcSet || producto?.imagemobile?.mediaItemUrl}
                label={producto?.label}
                title={producto?.title || producto?.name}
                description={producto?.description}
                href={
                  getTranslation({ link: producto?.page }, "uri", {
                    code: i18n?.language?.toUpperCase(),
                  }) || producto.href
                }
                key={`ebox-${index}`}
                link={producto?.link}
                price={producto?.price}
                producto={producto}
                selected={selected?.length}
              />
            );
          })}
          <div className="spacer"> </div>
        </div>
        <div className="scroll-indicator" id="indicator-container">
          <div className="scroll-indicator-bar" id="myBar"></div>
        </div>
      </div>
    );
  };

  const renderAlojamiento = () => {
    return <div><div className="row center">
      <div className={`noche${selected == 1 ? ' selected' : ''}`} onClick={() => {
        setSelected(1);
        removeItemFromEbox(alojamiento2Noche, alojamiento1Noche)


      }}>
        <div className="row-title">
          <div className="option"><span /></div>
          <Text element="h4" >
            {t("1noche")}
          </Text></div>
        <Text element="span" className="disponible">
          {t("disponible")}
        </Text>
        <Text element="span" className="disponible" style={{ fontSize: 17, marginBottom: 5 }}>
          {`${Numeral(total1Noche).format("1,000[.]00$")}`}
        </Text>
        {!hidePriceDetails &&
          <Text element="span" className="disponible" style={{ fontSize: 11, marginTop: 0, marginLeft: 10 }} >
            {`${t("1nochePrecio")} - ${Numeral(alojamiento1Noche?.price).format("1,000[.]00$")}`}
          </Text>
        }
        {!hidePriceDetails && map(precioFijas, (fija) => {
          return <Text element="span" className="disponible" style={{ fontSize: 11, marginTop: 0, marginLeft: 10 }} >
            {`${fija}`}
          </Text>
        })}

      </div>
      <div className={`noche${selected == 2 ? ' selected' : ''}`} onClick={() => {
        setSelected(2);
        removeItemFromEbox(alojamiento1Noche, alojamiento2Noche,)


      }}>
        <div className="row-title">
          <div className="option"><span /></div>
          <Text element="h4" >
            {t("2noches")}
          </Text></div>
        <Text element="span" className="disponible">
          {t("disponible2noches")}
        </Text>
        <Text element="span" className="disponible" style={{ fontSize: 17, marginBottom: 5 }}>
          {`${Numeral(total2Noches).format("1,000[.]00$")}`}
        </Text>
        {!hidePriceDetails &&
          <Text element="span" className="disponible" style={{ fontSize: 11, marginTop: 0, marginLeft: 10 }} >
            {`${t("2nochesPrecio")} - ${Numeral(alojamiento2Noche?.price).format("1,000[.]00$")}`}
          </Text>
        }
        {!hidePriceDetails && map(precioFijas, (fija) => {
          return <Text element="span" className="disponible" style={{ fontSize: 11, marginTop: 0, marginLeft: 10 }} >
            {`${fija}`}
          </Text>
        })}
      </div>
    </div> </div>;
  };

  if (!singlecolumn && !singleColumn) {
    return (
      <>
        {navlink ? (
          <a className="reference" style={{ top: -90 }} id={navlink} />
        ) : null}
        <div
          className={`select-e-box horizontal ${className || classname || ""}${tipo == "Dias" ? " alojamiento" : ""
            }`}
          ref={myRef2}
        >
          <div>
            {subtitle ? <Text element="h1">{subtitle}</Text> : null}

            <Text
              element={element}
              animated={animated}
              className={textClass || textclass}
            >
              {title}
            </Text>
            {contenidodebajo ?
              <ParagraphText
                content={contenidodebajo}
                singleColumn={true}
                className={'no-margin-center'}
              />
              : null}

            {text && text?.length ? (
              <ParagraphText
                text={text}
                content={content}
                singleColumn={true}
              />
            ) : null}
          </div>
          {tipo == "Dias"
            ? renderAlojamiento()
            : _products?.length
              ? renderCards()
              : null}

          {/* {contenidodebajo ?
          <ParagraphText
            text={text}
            content={contenidodebajo}
            singleColumn={true}
          />
          : null} */}
        </div >
      </>
    )
  }
  return (
    <>
      {navlink ? (
        <a className="reference" style={{ top: -90 }} id={navlink} />
      ) : null}

      <div
        className={`select-e-box ${className || classname || ""}`}
        ref={myRef2}
      >
        {subtitle ? <Text element="h1">{subtitle}</Text> : null}

        <Text
          element={element}
          animated={animated}
          className={textClass || textclass}
        >
          {title}
        </Text>

        <ParagraphText
          text={text}
          content={content}
          singleColumn={singleColumn || singlecolumn}
        />

        {tipo == "Dias"
          ? renderAlojamiento()
          : products?.length
            ? renderCards()
            : null}

        {
          <ParagraphText
            text={text}
            className={"duplicate"}
            singleColumn={singleColumn || singlecolumn}
          />
        }
      </div>
    </>
  );
};

export default SelectEbox;
